export default __webpack_public_path__ + "static/media/dotsLoader.b98a8c76.svg";